import React from 'react';
import cx from 'classnames';

import {
  IntlManager,
  useApplicationState,
  useBetslipState,
  useObservableOddsContext,
} from '@atlas/core';
import { Button, currencySymbols, Label, Loader } from '@atlas/ui';

const BetslipEuropeanPlaceBetButton = props => {
  const { betAmount, betAmountWarning, disabled, onSubmit } = props;

  const { acceptAllOdds, hasUnacceptedOdds } = useObservableOddsContext();
  const { loading } = useBetslipState();
  const {
    wallet: { currency },
  } = useApplicationState();

  const currencySymbol = currencySymbols[currency] || '';
  const betAmountDecimal = IntlManager.formatMoney(betAmount);

  const handleSubmit = React.useCallback(() => {
    // Accepting odds changes
    if (hasUnacceptedOdds) {
      return acceptAllOdds();
    }

    // Placing bets
    return onSubmit();
  }, [onSubmit, acceptAllOdds, hasUnacceptedOdds]);

  const betButtonError = React.useMemo(() => {
    if (loading) {
      return { icon: <Loader /> };
    }

    if (disabled) {
      return { message: 'remove_inactive_outcomes_to_bet' };
    }

    if (betAmountWarning) {
      return { message: 'place_amount_to_bet' };
    }

    return null;
  }, [disabled, loading, betAmountWarning]);

  /*
  FIXME: Should be removed
  */
  const betButtonText = React.useMemo(() => {
    if (betButtonError) {
      if (betButtonError.icon) return betButtonError.icon;
      return <Label message={betButtonError.message} />;
    }

    const formattedBetAmount = `${currencySymbol}${betAmountDecimal}`;
    const params = { value: formattedBetAmount };

    if (hasUnacceptedOdds) {
      return <Label message="betslip_accept_odds_changes" params={params} />;
    }

    return <Label message="bet_amount_now" params={params} />;
  }, [betButtonError, betAmountDecimal, currencySymbol, hasUnacceptedOdds]);

  const betButtonClassName = cx('big block', { buttonBet__acceptChanges: hasUnacceptedOdds });

  return (
    <Button
      className={betButtonClassName}
      disabled={!!betButtonError || loading}
      onClick={handleSubmit}
    >
      {betButtonText}
    </Button>
  );
};

export default BetslipEuropeanPlaceBetButton;
